
import React from "react";
import { ShieldCheck, Search, Clock } from "lucide-react";

const BenefitsSection: React.FC = () => {
  return (
    <section className="bg-gray-50 py-12 md:py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          <div className="bg-white p-4 md:p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-start mb-4">
              <div className="bg-blue-100 p-3 rounded-full mr-4">
                <Search className="h-6 w-6 text-blue-600" />
              </div>
              <div>
                <h3 className="text-lg md:text-xl font-semibold mb-2">Kätevä vertailu</h3>
                <p className="text-gray-600">
                  Yhdellä hakemuksella vertailet lainatarjouksia useista pankeista. Kilpailutamme puolestasi, sinun ei tarvitse asioida jokaisen pankin kanssa erikseen.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white p-4 md:p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-start mb-4">
              <div className="bg-blue-100 p-3 rounded-full mr-4">
                <ShieldCheck className="h-6 w-6 text-blue-600" />
              </div>
              <div>
                <h3 className="text-lg md:text-xl font-semibold mb-2">Turvallinen palvelu</h3>
                <p className="text-gray-600">
                  Palvelumme on turvallinen ja tietosi käsitellään luottamuksellisesti tietosuojaselosteemme mukaisesti.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white p-4 md:p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-start mb-4">
              <div className="bg-blue-100 p-3 rounded-full mr-4">
                <Clock className="h-6 w-6 text-blue-600" />
              </div>
              <div>
                <h3 className="text-lg md:text-xl font-semibold mb-2">Säästä aikaa</h3>
                <p className="text-gray-600">
                  Kilpailutamme lainatarjoukset puolestasi yli 20 rahoitusyhtiössä. Saat parhaat tarjoukset nopeasti ja vaivattomasti.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
